import {api} from '@eksab/api';
import {AxiosError} from 'axios';
import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {useAccessToken} from '@eksab/hooks';

export type Competition = {
  id: number;
  name: string;
};

const queryFn = (isLoggedIn: boolean) => () =>
  api.get<WithPagination<Competition[]>>('v2/competitions?for-user-created-fantasy=1').then((res) => res.data);
const queryKey = (isLoggedIn: boolean) => ['groups', 'list-competitions', isLoggedIn];

export function useCompetitionsQuery(options?: UseQueryOptions<WithPagination<Competition[]>, AxiosError>) {
  const isLoggedIn = !!useAccessToken()?.data;
  return useQuery<WithPagination<Competition[]>, AxiosError>(queryKey(isLoggedIn), queryFn(isLoggedIn), options);
}

useCompetitionsQuery.queryFn = queryFn;
useCompetitionsQuery.queryKey = queryKey;
